import { CareerSiteSettings } from 'api-clients/monolith';
import { ChatIcon } from 'icons/chat-icon';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface FaiWidget {
  dispatchMessage: (payload: {
    name: string;
    args?: { message?: string };
  }) => void;
}

declare global {
  interface Window {
    faiWidget?: FaiWidget;
  }
}

interface ChatWidgetProps {
  brandSetting: CareerSiteSettings;
}

export function ChatWidget({ brandSetting }: ChatWidgetProps) {
  const postMessageToWidget = (message?: string) => {
    if (!window || !window.faiWidget) {
      return;
    }

    window.faiWidget.dispatchMessage({
      name: 'x-fai-window-maximize',
    });

    if (message) {
      window.faiWidget?.dispatchMessage({
        name: 'x-fai-window-post-message',
        args: { message },
      });
    }
  };

  const handleTagClick = (content: string) => {
    postMessageToWidget(content);
  };

  if (
    !brandSetting?.show_chat_agent_widget ||
    !brandSetting?.show_faq_chatbot_by_default
  ) {
    return null;
  }

  return (
    <div className="mx-auto flex w-full flex-wrap items-center justify-center gap-2 md:w-2/3 lg:w-1/2">
      {brandSetting?.prefilled_faq_chatbot_questions?.map(message => (
        <button
          key={message}
          type="button"
          onClick={() => handleTagClick(message)}
          className="bg-primary-50 h-8 rounded-2xl px-3 py-2 text-xs leading-4"
        >
          {message}
        </button>
      ))}
      <button
        type="button"
        onClick={() => postMessageToWidget()}
        className="bg-primary-foreground text-primary flex h-10 items-center gap-1 rounded-full px-4 py-2 text-sm font-medium leading-5"
      >
        <ChatIcon />
        <FormattedMessage
          defaultMessage="Chat with us"
          description="Chat with us button label"
        />
      </button>
    </div>
  );
}
